import { css } from 'styled-components';

const small = () => css`
  height: 24px;
  padding: 5px 8px;
`;

export { small };
